import { Divider } from 'antd'

export function SL_Divider(props) {
    return <Divider className="my-4 bg-fit-gray-200" {...props} />
}
